// How search results are rendered — cards vs. compact rows — and the page
// size each view uses. The choice is remembered in localStorage, independent
// of any single search, so it persists across browser sessions and searches.

import type { ResultViewMode } from './types';

const VIEW_MODE_STORAGE_KEY = 'ara_search_view_mode';

export const DEFAULT_VIEW_MODE: ResultViewMode = 'cards';

// Compact rows show far less per result, so a page holds more of them.
const RESULTS_PER_PAGE: Record<ResultViewMode, number> = {
  cards: 10,
  compact: 25,
};

export function getResultsPerPage(viewMode: ResultViewMode): number {
  return RESULTS_PER_PAGE[viewMode];
}

function isResultViewMode(value: unknown): value is ResultViewMode {
  return value === 'cards' || value === 'compact';
}

/** The user's last-chosen view mode, or the default if none was ever stored. */
export function readStoredViewMode(): ResultViewMode {
  try {
    const raw = localStorage.getItem(VIEW_MODE_STORAGE_KEY);
    return isResultViewMode(raw) ? raw : DEFAULT_VIEW_MODE;
  } catch {
    return DEFAULT_VIEW_MODE;
  }
}

export function writeStoredViewMode(viewMode: ResultViewMode): void {
  try {
    localStorage.setItem(VIEW_MODE_STORAGE_KEY, viewMode);
  } catch {
    /* can be ignored */
  }
}
